import React, { useEffect } from 'react';
import { BRANDING_VARIANTS } from './BrandingVariations';
import { useScreenSize } from '../../contexts/ScreenSizeContext';

interface BrandingSliderProps {
  selectedVariantId: string;
  onSelectVariant: (variantId: string) => void;
}

export default function BrandingSlider({
  selectedVariantId,
  onSelectVariant,
}: BrandingSliderProps) {
  const screen = useScreenSize();

  // Auto-rotate through variants every 2.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      const currentIndex = BRANDING_VARIANTS.findIndex(
        (v) => v.id === selectedVariantId
      );
      const nextIndex = (currentIndex + 1) % BRANDING_VARIANTS.length;
      onSelectVariant(BRANDING_VARIANTS[nextIndex].id);
    }, 2500);

    return () => clearInterval(interval);
  }, [selectedVariantId, onSelectVariant]);

  return (
    <div
      style={{
        marginTop: '0.3rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: screen.isMobile ? '0.5rem' : '0.75rem',
        width: '100%',
        maxWidth: screen.isMobile ? '240px' : '100%',
        padding: screen.isMobile ? '0 0.5rem' : 0,
        boxSizing: 'border-box',
      }}
    >
      {BRANDING_VARIANTS.map((variant) => (
        <button
          key={variant.id}
          onClick={() => onSelectVariant(variant.id)}
          title={variant.name}
          style={{
            width: selectedVariantId === variant.id ? '16px' : '11px',
            height: selectedVariantId === variant.id ? '16px' : '11px',
            borderRadius: '50%',
            backgroundColor: variant.color,
            border: 'none',
            cursor: 'pointer',
            transition: 'width 0.3s ease, height 0.3s ease',
            padding: 0,
            flexShrink: 0,
          }}
        />
      ))}
    </div>
  );
}
